<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">Swords and Deviltry</h1>
<h2 class="subtitle">The Adventures of Fafhrd and the Gray Mouser: Book 1</h2>
<p class="author">Fritz Leiber</p>
<p class="colophon"><img alt="Open Road logo" src="images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?2630014d